import Card from '@/components/UI/Card';
import PiChart from '@/components/UI/Chart/PiChart';
import { SalesByCategory } from '@/interfaces/dashboard.interface';
import React from 'react';

interface ChartResponse {
  salesByCategory: SalesByCategory[] | [];
}

const DashboardCharts: React.FC<ChartResponse> = ({ salesByCategory }) => {
  return (
    <Card className="max-h-fit">
      <div className="flex justify-between items-center mb-5">
        <h3 className="text-base text-black">Orders By Category</h3>
      </div>

      <div>
        <PiChart
          data={
            salesByCategory.map((item) => ({
              name: item?.name,
              revenue: item?.count,
            })) || []
          }
        />
        {/* <BarGraph data={topCustomers?.bySales.map((item) => ({ name: item.customerName, count: item.count })) || []} isLoading={false} /> */}
      </div>
    </Card>
  );
};

export default DashboardCharts;
